import { ChevronRight } from "lucide-react";
import { cn } from "../lib/utils";
import { useLocation, useNavigate } from "react-router-dom";

const marketingLinks = [
  { id: "email-templates", label: "Email Templating", path: "/marketing/email-templates" },
  { id: "sms-templates", label: "SMS Templating", path: "/marketing/sms-templates" },
  { id: "campaigns", label: "Campaign Management", path: "/marketing/campaigns" },
  { id: "campaign-scheduling", label: "Campaign Scheduling", path: "/marketing/campaign-scheduling" },
];

export default function MarketingSubSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeId =
    marketingLinks.find((link) => location.pathname.startsWith(link.path))?.id ??
    "email-templates";

  return (
    <div className="relative w-full layout:w-56 layout:ml-2 layout:mt-3">
      <div className="flex flex-row layout:flex-col overflow-x-auto layout:overflow-y-auto w-full bg-white py-2 layout:py-4 border-b layout:border-none scrollbar-hide relative">
        {marketingLinks.map((item) => {
          const isActive = activeId === item.id;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={cn(
                "relative flex items-center px-4 py-2 text-[14px] layout:text-[15px] font-medium text-left transition-all duration-200 group whitespace-nowrap",
                isActive ? "text-purple-600" : "text-gray-800 hover:text-purple-600"
              )}
            >
              <ChevronRight
                className={cn(
                  "absolute left-0 w-4 h-4 opacity-0 transform transition-all duration-200 hidden layout:block",
                  isActive
                    ? "opacity-100 text-purple-600 translate-x-0"
                    : "group-hover:opacity-100 group-hover:text-purple-600 group-hover:translate-x-0"
                )}
              />
              <span
                className={cn(
                  "transition-all duration-200",
                  isActive ? "layout:translate-x-4" : "layout:group-hover:translate-x-4",
                  isActive && "border-b-2 border-purple-600 layout:border-none pb-1 layout:pb-0"
                )}
              >
                {item.label}
              </span>
            </button>
          );
        })}
        <div className="layout:hidden absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </div>
  );
}

